import { useRecoilState } from "recoil"
import { FormDataErrorState } from "hooks/form-data/FormDataState"

export const useGlobalFormDataError = (id: string) => {
    return useRecoilState(FormDataErrorState(id))
}
